import { render, staticRenderFns } from "./SearchClientForm.vue?vue&type=template&id=bceb36cc"
import script from "./SearchClientForm.vue?vue&type=script&lang=js"
export * from "./SearchClientForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports